import React, { Fragment, useEffect, useState } from "react";
import "./Bulk.css";
import { backend, API_URL } from "../../../config";
import {
  Typography,
  Grid,
  Button,
  Table,
  TableContainer,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Modal,
  CircularProgress,
  Select,
  Input,
  MenuItem,
  InputLabel,
  IconButton,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { CSVReader } from "react-papaparse";

import readXlsxFile from "read-excel-file";
import writeXlsxFile from "write-excel-file";

import ErrorIcon from "@mui/icons-material/Error";

const useStyles = makeStyles((theme) => ({
  root: {
    "& > *": {
      margin: theme.spacing(1),
    },
  },
  input: {
    display: "none",
  },
  paper: {
    marginTop: theme.spacing(5),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  buttons: {
    display: "flex",
    justifyContent: "flex-end",
  },
  button: {
    marginTop: theme.spacing(3),
    marginLeft: theme.spacing(1),
  },
  modal: {
    position: "absolute",
    width: 400,
    backgroundColor: "#fff",
    border: "1px solid rgba(0,0,0,.2)",
    borderRadius: ".3rem",
    boxShadow: theme.shadows[5],
    padding: "1rem",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
  },
}));

const columnsHeader = [
  { id: "warehouse", label: "Warehouse", type: "text" },
  { id: "bin", label: "Bin Location", type: "text" },
  { id: "upc", label: "UPC", type: "text" },
  { id: "name", label: "Name", type: "text" },
  { id: "unit_price", label: "Unit Price", type: "number" },
  { id: "case_price", label: "Case Price", type: "number" },
  { id: "unit_type", label: "Unit Type", type: "text" },
  { id: "units_per_case", label: "Units per Case", type: "number" },
  { id: "weight_type", label: "Weight Type", type: "text" },
  { id: "average_unit_weight", label: "Average Unit Weight", type: "number" },
  { id: "average_case_weight", label: "Average Case Weight", type: "number" },
  { id: "stock_level", label: "Stock Level", type: "number" },
  { id: "tax_default", label: "Tax Default", type: "checkbox" },
];

export const Bulk = (props) => {
  const classes = useStyles();

  const [importedData, setImportedData] = useState([]);
  const [importedDataFull, setImportedDataFull] = useState([]);
  const [errorInfo, setErrorInfo] = useState({ error: false, message: "" });
  const [errorModal, setErrorModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [exportModal, setExportModal] = useState(false);
  const [confirmModal, setConfirmModal] = useState(false);
  const [loadingFlag, setLoadingFlag] = useState(false);
  const [finishedFlag, setFinishedFlag] = useState(false);
  const [warehouseId, setWarehouseId] = useState("");
  const [warehouses, setWarehouses] = useState([]);

  const handleOnDrop = (data, file) => {
    if (errorInfo.error) {
      setErrorInfo({ error: false, message: "" });
    }

    let dataImported = [];

    switch (file.type) {
      case "text/csv":
        const foundHeaders = headersValidated(data[0].data);

        if (!foundHeaders) return;

        const indexHeaders = headersIndexes(data[0].data);

        data
          .map((item) => item.data)
          .forEach((item) => {
            if (item.length > 1) {
              let itemMap = {};

              Object.keys(indexHeaders).forEach((id) => {
                itemMap[id] = item[indexHeaders[id]];
              });

              itemMap.modified = false;
              itemMap.saved = false;
              itemMap.error = false;
              itemMap.error_message = "";

              dataImported.push(itemMap);
            }
          });

        setImportedData(dataImported);
        setImportedDataFull(dataImported);

        break;
      case "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
        readXlsxFile(file).then((data) => {
          const foundHeaders = headersValidated(data[0]);

          if (!foundHeaders) return;

          const indexHeaders = headersIndexes(data[0]);

          data.forEach((item) => {
            if (item.length > 1) {
              let itemMap = {};

              Object.keys(indexHeaders).forEach((id) => {
                itemMap[id] = item[indexHeaders[id]];
              });

              const warehouseObj = warehouses.find(
                (wItem) => wItem.id === +itemMap.warehouse,
              );

              if (warehouseObj) {
                itemMap.warehouse = warehouseObj.name;
              }

              itemMap.modified = false;
              itemMap.saved = false;
              itemMap.error = false;
              itemMap.error_message = "";

              dataImported.push(itemMap);
            }
          });

          setImportedData(dataImported);
          setImportedDataFull(dataImported);
        });

        break;
      default:
        setErrorInfo({
          error: true,
          message:
            "The imported file it's not compatible. Please use a .csv or .xlsx file.",
        });
    }
  };

  const headersValidated = (data) => {
    if (!data.length) {
      setErrorInfo({
        error: true,
        message: "Couldn't find any header information in the imported file.",
      });

      return false;
    }

    const foundAllHeaders = columnsHeader.every((item) => {
      const isIncluded = data.includes(item.label);

      if (!isIncluded) console.log("missing header: ", item.label);

      return isIncluded;
    });

    if (!foundAllHeaders) {
      setErrorInfo({
        error: true,
        message:
          "The imported file is missing one or multiple headers it should contain the following headers: Warehouse, Bin Location, UPC, Name, Unit Price, Case Price, Unit Type, Units per Case, Weight Type, Average Unit Weight, Average Case Weight, Stock Level",
      });
      setImportedData([]);
      setImportedDataFull([]);
    }

    return foundAllHeaders;
  };

  const headersIndexes = (data) => {
    let hIndexesObj = {};

    columnsHeader.forEach((item, index) => {
      const importedHeaderIndex = data.findIndex(
        (iHItem) => iHItem === item.label,
      );

      if (importedHeaderIndex === -1) {
      } else {
        hIndexesObj[item.id] = importedHeaderIndex;
      }
    });

    return hIndexesObj;
  };

  const handleChange = (e) => {
    const { checked, name, value } = e.target;
    const [, rowId, , columnId] = name.split("-");

    if (name === "warehouseExport") {
      setWarehouseId(value);
    } else {
      if (["warehouse", "upc"].includes(columnId)) return;

      const columnData = columnsHeader.find((item) => item.id === columnId);

      setImportedData((prevState) =>
        prevState.map((item, index) => {
          if (+rowId === index) {
            item[columnId] =
              columnData && columnData.type === "checkbox" ? checked : value;
            item.modified = true;

            return item;
          } else {
            return item;
          }
        }),
      );
    }
  };

  const handleClickInventoryExport = async () => {
    setLoadingFlag(true);

    await backend
      .get(`${API_URL}productedit/?no_page=1&warehouse=${warehouseId}`)
      .then(({ data }) => {
        if (data.length) {
          const columnsHeaderMapped = columnsHeader.map((item) => item.label);
          const itemsMapped = data.map((item) => [
            item.warehouse,
            item.bin,
            item.upc,
            item.name,
            item.unit_price,
            item.case_price,
            item.unit_type,
            item.units_per_case,
            item.weight_type,
            item.average_unit_weight,
            item.average_case_weight,
            item.stock_level,
            item.tax_default,
          ]);

          const inventoryDataMerge = [columnsHeaderMapped, ...itemsMapped];

          const inventoryDataExport = inventoryDataMerge.map((row, rowIndex) =>
            row.map((cell, cellIndex) => {
              let cellObj = { value: cell };

              if (rowIndex === 0) return cellObj;

              if (cellIndex === 0) {
                if (cell) {
                  cellObj.value = cellObj.value.id;
                } else {
                  cellObj.value = 0;
                }
              }

              if (cellIndex === 2) {
                cellObj.value = "'" + cellObj.value;
              }

              return cellObj;
            }),
          );

          const cDate = new Date();
          const cDateString = new Date(
            cDate.getTime() - cDate.getTimezoneOffset() * 60000,
          ).toISOString();

          writeXlsxFile(inventoryDataExport, {
            fileName: `warehouse${warehouseId} (${cDateString}).xlsx`,
          });
          setLoadingFlag(false);
          setFinishedFlag(true);
        } else {
          setErrorInfo({
            error: true,
            message:
              "Couldn't find any information from the selected warehouse.",
          });
        }
      })
      .catch((error) => {
        console.log(error);
        const errorData = error.response.data;

        setErrorInfo({
          error: true,
          message:
            typeof errorData === "object"
              ? errorData.hasOwnProperty("message")
                ? errorData.message
                : errorData.detail
              : error.message,
        });
      });
  };

  const sendRequest = async () => {
    setLoadingFlag(true);

    Promise.all(
      importedData.map(async (item, index) => {
        // todo: implement modified and saved flags for each row (map imported data to key: value instead of indexed)

        if (index === 0 || item.saved) return;

        const itemObj = {
          ...item,
          upc: item.upc === null ? null : +item.upc.replace("'", ""),
          weight_type: item.weight_type === null ? "" : item.weight_type,
        };

        delete itemObj.warehouse;
        delete itemObj.modified;
        delete itemObj.saved;
        delete itemObj.error;
        delete itemObj.error_message;

        if (itemObj.case_price === null) {
          delete itemObj.case_price;
        }

        await backend
          .patch(`${API_URL}productedit/${itemObj.upc}`, itemObj)
          .then(() => {
            item.modified = false;
            item.saved = true;
            item.error = false;
            item.error_message = "";
          })
          .catch((error) => {
            console.log(error);
            const errorData = error.response.data;

            item.modified = false;
            item.saved = false;
            item.error = true;
            item.error_message = JSON.stringify(errorData);
          });

        return item;
      }),
    ).then((result) => {
      setImportedData((prevState) => {
        const filteredData = result.filter(
          (item) => item !== undefined && !item.saved,
        );

        return filteredData.length ? [prevState[0], ...filteredData] : [];
      });
      setLoadingFlag(false);
      setFinishedFlag(true);
    });
  };

  const resolveRequest = () => {
    setLoadingFlag(false);
    setFinishedFlag(false);
    toggleConfirmModal();
    setErrorInfo({ error: false, message: "" });
  };

  const resolveExporting = () => {
    setLoadingFlag(false);
    setFinishedFlag(false);
    toggleExportModal();
    setErrorInfo({ error: false, message: "" });
  };

  const toggleConfirmModal = () => setConfirmModal(!confirmModal);

  const confirmModalContent = (
    <div className={classes.modal}>
      {!loadingFlag && !finishedFlag ? (
        <>
          Are you sure you want to save the changes to the imported items?
          <br />
          <br />
          <b>Note: </b>This process will override the current information with
          the imported/edited in the previous table.
          <div align="right">
            <Button
              onClick={() => toggleConfirmModal()}
              className={classes.button}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={() => sendRequest()}
              className={classes.button}
            >
              Confirm
            </Button>
          </div>
        </>
      ) : loadingFlag ? (
        <>
          <div align="center">
            <CircularProgress />
            <div>
              Saving imported items <br />
              This may take some time relative to the number of items
            </div>
          </div>
          {errorInfo.error ? (
            <>
              <br />
              <br />
              There was an error while saving the items information
              <br />
              <br />
              <span
                style={{
                  color: "red",
                  wordBreak: "break-word",
                  maxHeight: 160,
                  overflow: "hidden",
                  display: "inline-block",
                }}
              >
                <b>Error:</b>
                <br />
                {errorInfo.message}
              </span>
              <div align="right">
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => resolveRequest()}
                  className={classes.button}
                >
                  Continue
                </Button>
              </div>
            </>
          ) : (
            <></>
          )}
        </>
      ) : (
        <>
          {!importedData.length
            ? `A total of ${importedDataFull.length - 1} items were updated`
            : `${
                importedDataFull.length - importedData.length
              } items have been successfully updated`}
          <div align="right">
            <Button
              variant="contained"
              color="primary"
              onClick={() => resolveRequest()}
              className={classes.button}
            >
              Close
            </Button>
          </div>
        </>
      )}
    </div>
  );

  const toggleExportModal = () => setExportModal(!exportModal);

  const exportModalContent = (
    <div className={classes.modal}>
      {!loadingFlag && !finishedFlag ? (
        <>
          Are you sure you want to export items from the selected warehouse?
          <br />
          <div align="right">
            <Button
              onClick={() => toggleExportModal()}
              className={classes.button}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={() => handleClickInventoryExport()}
              className={classes.button}
            >
              Confirm
            </Button>
          </div>
        </>
      ) : loadingFlag ? (
        <>
          <div align="center">
            <CircularProgress />
            <div>
              Requesting and exporting warehouse information <br />
              This may take some time relative to the number of items
            </div>
          </div>
          {errorInfo.error ? (
            <>
              <br />
              <br />
              There was an error while exporting the warehouse information
              <br />
              <br />
              <span
                style={{
                  color: "red",
                  wordBreak: "break-word",
                  maxHeight: 160,
                  overflow: "hidden",
                  display: "inline-block",
                }}
              >
                <b>Error:</b>
                <br />
                {errorInfo.message}
              </span>
              <div align="right">
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => resolveExporting()}
                  className={classes.button}
                >
                  Continue
                </Button>
              </div>
            </>
          ) : (
            <></>
          )}
        </>
      ) : (
        <>
          Warehouse information have been successfully exported
          <div align="right">
            <Button
              variant="contained"
              color="primary"
              onClick={() => resolveExporting()}
              className={classes.button}
            >
              Close
            </Button>
          </div>
        </>
      )}
    </div>
  );

  const toggleErrorModal = (msg = null) => {
    setErrorMessage(msg ? msg : "");
    setErrorModal(!errorModal);
  };

  const errorModalContent = (
    <div className={classes.modal}>
      <>
        <div>
          <div>Error</div>
        </div>
        <br />
        <span
          style={{
            color: "red",
            wordBreak: "break-word",
            maxHeight: 160,
            overflow: "hidden",
            display: "inline-block",
          }}
        >
          {errorMessage}
        </span>
        <div align="right">
          <Button
            variant="contained"
            color="primary"
            onClick={() => toggleErrorModal()}
            className={classes.button}
          >
            Close
          </Button>
        </div>
      </>
    </div>
  );

  useEffect(() => {
    const warehousesGet = async () => {
      await backend.get(`${API_URL}warehouses?no_page=1`).then(({ data }) => {
        const dataMap = data
          .filter((item) => item.id !== 2)
          .map((item) => ({ id: item.id, name: item.name }));

        setWarehouses(dataMap);
      });
    };

    if (!warehouses.length) {
      warehousesGet();
    }
  }, [warehouses]);

  return (
    <div className={`${classes.paper} inventory-bulk`}>
      <Modal open={confirmModal} onClose={toggleConfirmModal}>
        {confirmModalContent}
      </Modal>
      <Modal open={exportModal} onClose={toggleExportModal}>
        {exportModalContent}
      </Modal>
      <Modal open={errorModal} onClose={toggleErrorModal}>
        {errorModalContent}
      </Modal>
      <Grid
        container
        spacing={2}
        style={{ justifyContent: "center", textAlign: "center" }}
      >
        <Grid item xs={12} sm={12}>
          <Typography component="h6" variant="h6" align="center">
            Inventory Export
          </Typography>
        </Grid>
        <Grid item xs={12} sm={3}>
          <InputLabel shrink id="warehouseExportLabel" align="left">
            Warehouse
          </InputLabel>
          <Select
            fullWidth
            name="warehouseExport"
            input={<Input />}
            value={warehouseId}
            align="left"
            onChange={handleChange}
          >
            <MenuItem value="">None</MenuItem>
            {warehouses.map((warehouse) => (
              <MenuItem key={warehouse.id} value={warehouse.id}>
                {warehouse.name}
              </MenuItem>
            ))}
          </Select>
        </Grid>
        <Grid item xs={12} sm={12}>
          <Button
            variant="contained"
            color="primary"
            disabled={!warehouseId}
            onClick={() => toggleExportModal()}
          >
            Export CSV
          </Button>
        </Grid>
        <Grid item xs={12} sm={12}></Grid>
        <Grid item xs={12} sm={12}>
          <Typography component="h6" variant="h6" align="center">
            Inventory Import
          </Typography>
        </Grid>
        <Grid item xs={12} sm={12}>
          <Typography component="h4" align="center">
            Upload a CSV or XLSX file with items to update
          </Typography>
        </Grid>
        {errorInfo.error ? (
          <Grid item xs={12} sm={12}>
            <Typography component="h4" color="error">
              {errorInfo.message}
            </Typography>
          </Grid>
        ) : (
          <></>
        )}
        <Grid item xs={6} sm={6}>
          <CSVReader
            onDrop={handleOnDrop}
            accept="text/csv, .csv, .xlsx"
            noDrop
          ></CSVReader>
        </Grid>
        {importedData.length ? (
          <>
            <Grid item xs={12}></Grid>
            <Grid item xs={12}></Grid>
            <Grid item xs={12}></Grid>
            <Grid item xs={12} sm={12}>
              The imported file contains the following information: <br />
              <i>Make adjustments as necessary before importing</i>
            </Grid>
            <Grid item xs={12} sm={12}>
              <TableContainer sx={{ maxHeight: 600 }}>
                <Table stickyHeader aria-label="sticky table">
                  <TableHead>
                    <TableRow>
                      {columnsHeader.map((column) => (
                        <TableCell key={`header-${column.id}`} align={"center"}>
                          {column.label}
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {importedData.map((row, rIndex) =>
                      rIndex > 0 ? (
                        <TableRow hover tabIndex={-1} key={`row-${rIndex}`}>
                          {columnsHeader.map((column) => (
                            <TableCell
                              key={`row-${rIndex}-column-${column.id}`}
                            >
                              <Grid container spacing={row.error ? 1 : 0}>
                                {row.error && column.id === "warehouse" ? (
                                  <Grid item xs="auto">
                                    <IconButton
                                      onClick={() =>
                                        toggleErrorModal(row.error_message)
                                      }
                                    >
                                      <ErrorIcon color="error" />
                                    </IconButton>
                                  </Grid>
                                ) : (
                                  <></>
                                )}
                                <Grid item xs={true}>
                                  <input
                                    name={`row-${rIndex}-column-${column.id}`}
                                    value={
                                      row[column.id] !== null
                                        ? row[column.id]
                                        : column.type === "string"
                                          ? ""
                                          : 0
                                    }
                                    {...(column.type === "checkbox"
                                      ? {
                                          checked:
                                            row[column.id] !== null
                                              ? !!row[column.id]
                                              : false,
                                        }
                                      : undefined)}
                                    disabled={["warehouse", "upc"].includes(
                                      column.id,
                                    )}
                                    type={column.type}
                                    onChange={(e) => handleChange(e)}
                                  />
                                </Grid>
                              </Grid>
                            </TableCell>
                          ))}
                        </TableRow>
                      ) : (
                        <Fragment key={`row-${rIndex}`}></Fragment>
                      ),
                    )}
                    {!importedData.length ? (
                      <TableRow>
                        <TableCell align="center">
                          There are no items in the imported file
                        </TableCell>
                      </TableRow>
                    ) : (
                      <></>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>
            <Grid item xs={12} sm={12}>
              <Button
                variant="contained"
                color="primary"
                onClick={toggleConfirmModal}
                className={classes.button}
              >
                Import data
              </Button>
            </Grid>
          </>
        ) : (
          <></>
        )}
      </Grid>
    </div>
  );
};

export default Bulk;
